import { ComplaintCategory, ComplaintOrigin, ComplaintStatus } from '@zeus/index'

/** Libellés du registre des réclamations (#325), partagés par l'écran, le CSV et le formulaire de contact. */
export const COMPLAINT_CATEGORY_KEYS: Record<ComplaintCategory, string> = {
  [ComplaintCategory.QUESTION]: 'complaints.category.question',
  [ComplaintCategory.PEDAGOGICAL]: 'complaints.category.pedagogical',
  [ComplaintCategory.TECHNICAL]: 'complaints.category.technical',
  [ComplaintCategory.ADMINISTRATIVE]: 'complaints.category.administrative',
  [ComplaintCategory.REPORT]: 'complaints.category.report',
  [ComplaintCategory.OTHER]: 'complaints.category.other',
}

export const COMPLAINT_STATUS_KEYS: Record<ComplaintStatus, string> = {
  [ComplaintStatus.OPEN]: 'complaints.status.open',
  [ComplaintStatus.IN_PROGRESS]: 'complaints.status.inProgress',
  [ComplaintStatus.RESOLVED]: 'complaints.status.resolved',
}

/** Couleur d'état réservée, jamais la marque : « résolu » se lit en vert partout. */
export const COMPLAINT_STATUS_VARIANTS = {
  [ComplaintStatus.OPEN]: 'warningSubtle',
  [ComplaintStatus.IN_PROGRESS]: 'secondary',
  [ComplaintStatus.RESOLVED]: 'successSubtle',
} as const satisfies Record<ComplaintStatus, string>

export const COMPLAINT_ORIGIN_KEYS: Record<ComplaintOrigin, string> = {
  [ComplaintOrigin.CONTACT_FORM]: 'complaints.origin.contactForm',
  [ComplaintOrigin.MANUAL]: 'complaints.origin.manual',
}
